/**
 * @fileoverview Firebase project configuration derived from the environment.
 * @description Centralizes the Firebase Web SDK config object and the flag that gates whether
 * Firebase is initialized at all, so every consumer (Analytics, Cloud Messaging) checks
 * `isFirebaseConfigured` instead of re-deriving it from individual env vars.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { env } from '@/config/env'

export const firebaseConfig = {
  apiKey: env.firebaseApiKey ?? '',
  authDomain: env.firebaseAuthDomain ?? '',
  projectId: env.firebaseProjectId ?? '',
  storageBucket: env.firebaseStorageBucket ?? '',
  messagingSenderId: env.firebaseMessagingSenderId ?? '',
  appId: env.firebaseAppId ?? '',
  measurementId: env.firebaseMeasurementId ?? '',
}

// The core fields every Firebase product needs, regardless of which ones (Analytics, Messaging)
// a given fork actually uses. Leaving all VITE_FIREBASE_* vars blank (this blueprint's default,
// since no Firebase project exists yet) keeps this false, so Firebase never initializes.
export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId,
)
